import {api} from './api';
import {
  AuthResponse,
  CreateAccountRequest,
  LoginWithQrRequest,
  RequestMagicLinkRequest,
  VerifyMagicLinkRequest,
  SessionValidationResponse,
  QrCodeResponse,
  MessageResponse,
} from '../types';

export const authService = {
  async createAccount(request?: CreateAccountRequest): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>(
      '/api/v1/auth/create-account',
      request || {},
    );
    await api.setToken(response.sessionToken);
    return response;
  },

  async loginWithQr(request: LoginWithQrRequest): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>(
      '/api/v1/auth/login/qr',
      request,
    );
    await api.setToken(response.sessionToken);
    return response;
  },

  async requestMagicLink(
    request: RequestMagicLinkRequest,
  ): Promise<MessageResponse> {
    return api.post<MessageResponse>(
      '/api/v1/auth/magic-link/request',
      request,
    );
  },

  async verifyMagicLink(
    request: VerifyMagicLinkRequest,
  ): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>(
      '/api/v1/auth/magic-link/verify',
      request,
    );
    await api.setToken(response.sessionToken);
    return response;
  },

  async generateQrCode(): Promise<QrCodeResponse> {
    return api.post<QrCodeResponse>('/api/v1/auth/qr-code/generate');
  },

  async verifyEmail(token: string): Promise<MessageResponse> {
    return api.get<MessageResponse>(`/api/v1/auth/verify-email?token=${encodeURIComponent(token)}`);
  },

  async validateSession(): Promise<SessionValidationResponse> {
    return api.get<SessionValidationResponse>('/api/v1/auth/session');
  },

  async logout(): Promise<void> {
    await api.post('/api/v1/auth/logout');
    await api.clearToken();
  },

  async hasSession(): Promise<boolean> {
    return api.hasToken();
  },
};
